import React from 'react';
import { Skeleton } from '@mui/material';

function BannerPlaceholder() {
    return <Skeleton variant="square" sx={{ width: "100%", height: "60vh" }} />
}

export default BannerPlaceholder;